import { Level2OuterPageLoading } from "@octopusdeploy/design-system-components";
import { links } from "@octopusdeploy/portal-routes";
import { repository } from "~/clientInstance";
import { AsyncInternalRedirect } from "../AsyncInternalRedirect";
interface DefaultInsightsPageRedirectProps {
    spaceId: string;
}
export function DefaultInsightsPageRedirect({ spaceId }: DefaultInsightsPageRedirectProps) {
    return (<AsyncInternalRedirect loader={async () => {
            const licenseCheck = await repository.InsightsReports.getInsightsLicenseCheck();
            return licenseCheck.HasInsightsLicenseFeature ? links.insightReportListPage.generateUrl({ spaceId }) : links.insightsReportUpsellPage.generateUrl({ spaceId });
        }} renderWhenLoading={<Level2OuterPageLoading />}/>);
}
